// eslint-disable-next-line import/prefer-default-export
export const GET_ITEM = 'GET_ITEM';
export const GET_EDUCATIONS = 'GET_EDUCATIONS';
export const SET_MODAL = 'SET_MODAL';
export const SET_MODAL_FILTERS = 'SET_MODAL_FILTERS';
